import httpcommonFile from "../../baseUrl/httpcommonFile";
import httpcommonStorage from "../../baseUrl/httpcommonStorage";

const storage = (data) => {
  return httpcommonStorage.get(`/api/storage/usage`);
};

const uploadFolder = (formData,onProgress) => {
  console.log("uploadFolderSlice",formData)
  //debugger;
  return httpcommonFile.post(`/api/folders/upload`,formData,{
    headers: {
      'Content-Type': 'multipart/form-data',
  },
  onUploadProgress: (progressEvent) => {
    // Calculate the percentage of progress
    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
    if (onProgress) {
      // Call the onProgress function to pass the progress value
      onProgress(progress);
    }}
  });
};
const uploadFile = (userId,formData,onProgress) => {
  console.log("uploadFile userId",userId)
  return httpcommonFile.post(`/api/files/upload?userId=${userId}`,formData,{
    headers: {
      'Content-Type': 'multipart/form-data',
  },
  onUploadProgress: (progressEvent) => {
    // Calculate the percentage of progress
    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
    if (onProgress) {
      // Call the onProgress function to pass the progress value
      onProgress(progress);
    }}
  });
};
const uploadFolderService = {
  uploadFolder,
  storage,
  uploadFile
};

export default uploadFolderService;
